import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TradePlateComponent } from './trade-plate.component';

const routes: Routes = [
  { path: '', component: TradePlateComponent, data: { title: 'Trade Plates' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TradePlateRoutingModule {}

@NgModule({
  imports: [
    TradePlateRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TradePlateComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TradePlateModule {}
